import { atom, useAtom } from 'jotai';
export var timelineExpansionAtom = atom(false);
export function useTimelineExpanded() {
  return useAtom(timelineExpansionAtom);
}